import { ChangeEvent } from "react";
import { Typography, Button } from "@mui/material";
import usePagination from "@mui/material/usePagination";
import { Stack } from "@mui/material";
import { pluralize } from "~/lib/pluralize";
import {
  ChevronLeft as ChevronLeftIcon,
  ChevronRight as ChevronRightIcon,
} from "@mui/icons-material";

interface PaginationContainedProps {
  itemCount: number;
  count: number;
  page: number;
  onChange: (event: ChangeEvent<unknown>, value: number) => void;
  itemType?: string;
  itemPerPage?: number;
}

export default function PaginationContained({
  itemCount,
  count,
  page,
  onChange,
  itemType = "item",
  itemPerPage = 5,
}: PaginationContainedProps) {
  const { items } = usePagination({
    count,
    page,
    onChange,
  });

  const fromNumber = page * itemPerPage - itemPerPage + 1;
  const toNumber =
    page * itemPerPage > itemCount ? itemCount : page * itemPerPage;

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center">
      <Typography variant="body2" color="text.secondary">
        {`Showing ${fromNumber} - ${toNumber} of ${itemCount} ${pluralize(itemType, itemCount)}`}
      </Typography>
      <nav>
        <ul
          style={{ listStyle: "none", padding: 0, margin: 0, display: "flex" }}
        >
          {items.map(({ type, ...item }, index) => {
            let children = null;

            if (type === "previous") {
              children = (
                <Button
                  {...item}
                  size="small"
                  startIcon={<ChevronLeftIcon />}
                  sx={{ mr: 0.75 }}
                >
                  PREV
                </Button>
              );
            }

            if (type === "next") {
              children = (
                <Button {...item} size="small" endIcon={<ChevronRightIcon />}>
                  NEXT
                </Button>
              );
            }

            return <li key={index}>{children}</li>;
          })}
        </ul>
      </nav>
    </Stack>
  );
}
